import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { map, Observable, of, shareReplay } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { LanguageService } from '@spartacus/core';

@Component({
  selector: 'app-coreGuidesTab',
  templateUrl: './KbcoreGuidesTab.component.html',
  styleUrls: ['./KbcoreGuidesTab.component.scss'],
  standalone: false
})
export class KbCoreGuidesTabComponent {
  activeLanguage$!: Observable<string>;
  documentUrlsMap: { [key: string]: string } = {};

  @Input() Guides: any;

  constructor(
    private documentService: GetDocumentService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.Guides?.forEach((doc: any) => {
      if (doc?.code) {
        this.loadDocument(doc.code);
      }
    });
  }

  loadDocument(code: string): void {
    this.documentService
      .getDocumentByDocumentCode(code)
      .pipe(
        map((res: any) => res?.url ?? '')
      )
      .subscribe((url: string) => {
        this.documentUrlsMap[code] = url;
      });
  }

}
